<template>
  <el-row class="industryBox">
    <div class="tag">
      <span @click="handleChangeCity('hlj')" :class="{'active': areaName == 'hlj'}">黑龙江</span>
      <span @click="handleChangeCity('zh')" :class="{'active': areaName == 'zh'}">中国</span>
    </div>
    <div id="industryEchart2" :style="{ width: '100%', height: '235px' }"></div>
  </el-row>
</template>

<script>
import {onMounted, onUnmounted, ref} from 'vue'
import * as echarts from "echarts";
export default {
  name: "industryEchart2",
  data(){
    return {
        deviceName: 'ele1',
    }
  },
  setup() {
    /// 声明定义一下echart
    let areaName = ref('hlj');
    let echart = echarts;
    const hljData = [
    {branch: '电子元器件',comp: '科研单位/院校', num: 2448, dot: 16},
    {branch: '电子元器件',comp: '企业', num: 1184, dot: 8},
    {branch: '电子元器件',comp: '个人', num: 488,dot: 6},
    {branch: '电子测量仪器',comp: '科研单位/院校', num: 195, dot: 3},
    {branch: '电子测量仪器',comp: '企业', num: 116, dot: 2},
    {branch: '电子测量仪器',comp: '个人', num: 109, dot: 2},
    {branch: '广播电视设备',comp: '科研单位/院校', num: 21,dot: 0.5 },
    {branch: '广播电视设备',comp: '企业', num: 108,dot: 2},
    {branch: '广播电视设备',comp: '个人', num: 114,dot: 2.1},
    {branch: '电子雷达设备',comp: '科研单位/院校', num: 60,dot: 1},
    {branch: '电子雷达设备',comp: '企业', num: 50,dot: 1},
    {branch: '电子雷达设备',comp: '个人', num: 0,dot: 0},
    {branch: '电子专用设备',comp: '科研单位/院校', num: 29,dot: 0.5},
    {branch: '电子专用设备',comp: '企业', num: 27,dot: 0.5},
    {branch: '电子专用设备',comp: '个人', num: 6, dot: 0.2},
    ];
    const zhData = [
      {branch: '电子元器件',comp: '大专院校', num: 9606,dot: 9},
      {branch: '电子元器件',comp: '企业', num: 54250,dot: 20},
      {branch: '电子元器件',comp: '个人', num: 3399,dot: 4},
      {branch: '电子元器件',comp: '科研单位', num: 2592,dot: 3},
      {branch: '电子元器件',comp: '机关团体', num: 97,dot: 1},

      {branch: '电子测量仪器',comp: '大专院校', num: 2025,dot: 2.3},
      {branch: '电子测量仪器',comp: '企业', num: 7144,dot: 7},
      {branch: '电子测量仪器',comp: '个人', num: 1534,dot: 1.5},
      {branch: '电子测量仪器',comp: '科研单位', num: 653,dot: 0.6},
      {branch: '电子测量仪器',comp: '机关团体', num: 161,dot: 0.1},

      {branch: '广播电视设备',comp: '大专院校', num: 635,dot: 0.6},
      {branch: '广播电视设备',comp: '企业', num: 10193,dot: 10},
      {branch: '广播电视设备',comp: '个人', num: 777,dot: 0.7},
      {branch: '广播电视设备',comp: '科研单位', num: 281,dot: 0.2},
      {branch: '广播电视设备',comp: '机关团体', num: 20,dot: 0.1},

      {branch: '电子雷达设备',comp: '大专院校', num: 1247,dot: 1.2},
      {branch: '电子雷达设备',comp: '企业', num: 4072,dot: 4},
      {branch: '电子雷达设备',comp: '个人', num: 270,dot: 0.2},
      {branch: '电子雷达设备',comp: '科研单位', num: 864,dot: 0.8},
      {branch: '电子雷达设备',comp: '机关团体', num: 36,dot: 0.03},

      {branch: '电子专用设备',comp: '大专院校', num: 250,dot: 0.25},
      {branch: '电子专用设备',comp: '企业', num: 3040,dot: 3},
      {branch: '电子专用设备',comp: '个人', num: 45,dot: 0},
      {branch: '电子专用设备',comp: '科研单位', num: 139,dot: 0.01},
      {branch: '电子专用设备',comp: '机关团体', num: 5, dot: 0},
    ];
    let xData = ['电子元器件','电子测量仪器','广播电视设备','电子雷达设备','电子专用设备'];
    let hljYData = ['','科研单位/院校','企业','个人'];
    let zhYData = ['','大专院校','企业','个人','科研单位','机关团体'];
    onMounted(() => {
      industryEchart(xData, hljYData, hljData);
    });
    onUnmounted(() => {
      echart.dispose();
    });
    function industryEchart(xData, yData, data) {
      let chart = echart.init(document.getElementById("industryEchart2"));
      // 把配置和数据放这里
      chart.setOption({
        backgroundColor: 'rgb(0,0,0,0)',
        // padding: 10,
        grid: {
          left: '16%',
          top: 20,
          bottom: '10%',
        },
        xAxis: {
            // name: '技术分支',
            boundaryGap:['10%','0%'],
            scale: true,
            axisTick:{
              show: false,
            },
            axisLabel: {
              color: '#fff',
              formatter: function(params){
                return xData[params];
              }
            },
            interval: 1,
            splitNumber: xData.length,
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                // color: '#fff',
              }
            },
          },
          yAxis: {
            // name: '申请人类型',
            boundaryGap:['10%','10%'],
            nameTextStyle:{
              fontSize: 15,
              color: '#fff',
              // align: 'right',
              fontWeight: 'bold',
            },
            scale: true,
            interval: 1,
            // axisLine: {
            //   show: false,
            // },
            splitNumber:yData.length -1,
            axisTick:{
              show: false,
            },
            axisLabel: {
              show: true,
              formatter: function(idx){
                return yData[idx];
              },
              color: '#fff',
            },
            splitLine: {
              // show: true,
              lineStyle: {
                type: 'dashed',
                // color: '#fff',
              }
            },
          },
          series: data.map((d)=>{
            return {
              flexShrink: 0,
              type: 'scatter',
              label:{
                show: true,
                formatter: function(params){
                  return data[params.seriesIndex].num;
                },
                color: '#fff',
              },
              symbolSize: function() {
                return d.dot * 3
              //  return Math.sqrt(d.dot) / 5e2;
              },
              emphasis: {
                focus: 'series',
                label: {
                  show: true,
                  fontSize: 20,
                  formatter: function (param) {
                     return data[param.seriesIndex].num;
                  },
                  position: 'top'
                }
              },
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(25, 100, 150, 0.5)',
                shadowOffsetY: 5,
                color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                  {
                    offset: 0,
                    color: 'rgb(129, 227, 238)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(25, 183, 207)'
                  }
                ])
              },
              data:[
                [
                  xData.indexOf(d.branch),
                  yData.indexOf(d.comp),
                ]
              ]
            }

          })
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    function handleChangeCity(val) {
      let myChart = echarts.init(document.getElementById("industryEchart2"));
      myChart.clear();
      areaName.value = val;
      if(val == 'hlj') {
        // console.log(xData,'111')
        // console.log(hljYData, '222')
        console.log(hljData.value, '333')
         console.log(zhData, '333')
        industryEchart(xData,hljYData,hljData);
      } else {
        // console.log(xData,'111')
        // console.log(zhYData, '222')
        console.log(hljData, '333')
         console.log(zhData, '333')
        industryEchart(xData,zhYData,zhData);
      }
    }
    return { industryEchart, handleChangeCity, areaName, zhData, hljData};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .tag{
  margin: 0 auto;
  margin-top: 10px;
 }
 .tag2{
  margin: 20px auto;
 }
.tag2 div {
  display: inline-block;
  padding: 5px;
}
.tag span{
  display: inline-block;
  width: 60px;
  text-align: center;
  padding: 6px;
  cursor: pointer;
  color: #508cff;
  background: #0e2e6c;
 }
 .tag span.active,.tag2 div.active{
  color: #fff;
  background: #0071ff;
  font-weight: 500;
 }
</style>
